import { ABCClass } from '@slot-matrix/shared-types';
/**
 * Classify SKUs into ABC tiers using cumulative percentage method.
 * Sorts by metric value descending and assigns classes based on cumulative thresholds.
 */
export function classifyABC(skus, metricValues, config) {
    if (skus.length === 0)
        return [];
    // Build sortable entries
    const entries = skus.map((sku, index) => ({
        sku,
        metricValue: metricValues.get(sku.id) ?? 0,
        originalIndex: index,
    }));
    // Sort descending by metricValue, stable sort using originalIndex for ties
    entries.sort((a, b) => {
        const diff = b.metricValue - a.metricValue;
        return diff !== 0 ? diff : a.originalIndex - b.originalIndex;
    });
    // Total metric
    const totalMetric = entries.reduce((sum, e) => sum + e.metricValue, 0);
    // Handle all-zero case
    if (totalMetric === 0) {
        return entries.map((entry, i) => ({
            skuId: entry.sku.id,
            metric: config.metric,
            metricValue: 0,
            cumulativePercent: 0,
            rank: i + 1,
            assignedClass: ABCClass.C,
            isManualOverride: false,
            overrideReason: null,
        }));
    }
    // Clamp thresholds
    const thresholdA = config.thresholdA;
    const thresholdB = Math.min(config.thresholdB, 100 - thresholdA);
    // Assign classes
    let cumulativeValue = 0;
    return entries.map((entry, i) => {
        cumulativeValue += entry.metricValue;
        const cumulativePercent = (cumulativeValue / totalMetric) * 100;
        let assignedClass;
        if (cumulativePercent <= thresholdA) {
            assignedClass = ABCClass.A;
        }
        else if (cumulativePercent <= thresholdA + thresholdB) {
            assignedClass = ABCClass.B;
        }
        else {
            assignedClass = ABCClass.C;
        }
        return {
            skuId: entry.sku.id,
            metric: config.metric,
            metricValue: entry.metricValue,
            cumulativePercent,
            rank: i + 1,
            assignedClass,
            isManualOverride: false,
            overrideReason: null,
        };
    });
}
/**
 * Generate Pareto data points from ABC results for chart rendering.
 */
export function generateParetoData(results) {
    return results.map((r) => ({
        rank: r.rank,
        metricValue: r.metricValue,
        cumulativePercent: r.cumulativePercent,
        assignedClass: r.assignedClass,
        skuId: r.skuId,
    }));
}
//# sourceMappingURL=abcClassifier.js.map